import React from 'react';
import './StatusBarLoyalty.css';
import { StatusBarSvg } from '../StatusBarSvg';
import { svgTypes } from '../../enums/status-bar-svg.enum';

/**
 * Display player current loyalty points.
 * @param points
 * @param maxPoints
 * @param CustomSvgIcon
 * @returns {JSX.Element}
 * @constructor
 */
export const StatusBarLoyalty = ({
    points,
    maxPoints = 7,
    CustomSvgIcon = null,
}) => {
    const StatusBarIcon = CustomSvgIcon
        ? CustomSvgIcon
        : <StatusBarSvg
            svgType={svgTypes.CROWN}
            width={16}
            height={16}
        />;

    return (
        <div className='loyalty-wrapper'>
            {[...Array(maxPoints)].map((x, i) =>
                <span key={i} className={i+1 > points ? 'disabled-crown' : ''}>
                    {StatusBarIcon}
                </span>
            )}
        </div>
    );
};
